var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[(this.isManager())?_c('el-col',{attrs:{"span":23}},[_c('el-button',{attrs:{"icon":"fa fa-trash-alt","size":"small","type":"danger","circle":"","disabled":_vm.isViewOnly()},on:{"click":function($event){return _vm.deleteEntry()}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }